import React, { FC } from "react";
import { Block, BlockProps } from "baseui/block";
import { useStyletron } from "kanopi-components/theme/useStyletron";

export enum RowGap {
  Standard,
  Shortened,
}
type TPortalRow = {
  fullWidth?: boolean;
  bottomSpace?: RowGap;
};
export const PortalRow: FC<TPortalRow & BlockProps> = ({
  fullWidth = false,
  bottomSpace = RowGap.Shortened,
  paddingBottom = "scale900",
  paddingLeft = "scale700",
  paddingRight = "scale700",
  maxWidth,
  children,
  ...props
}) => {
  const [, theme] = useStyletron();

  return (
    <Block
      width={fullWidth ? "100%" : "auto"}
      maxWidth={maxWidth}
      paddingBottom={
        bottomSpace === RowGap.Standard ? theme.sizing.scale1600 : paddingBottom
      }
      paddingLeft={fullWidth ? theme.sizing.scale0 : paddingLeft}
      paddingRight={fullWidth ? theme.sizing.scale0 : paddingRight}
      {...props}
    >
      {children}
    </Block>
  );
};
